import React from "react";

function PageNotFound() {
  return <h2>404 - Page not found</h2>;
}

export default PageNotFound;
